export default class Toast {
  constructor() {
    this.$box = false;
    this.createContainer();
  }

  // 创建toastcontainer
  createContainer() {
    if (document.querySelector('#toast-container')) {
      this.$container = document.querySelector('#toast-container');
    } else {
      this.$container = document.createElement('div'); // 加载容器
      this.$container.id = 'toast-container'; // 容器加上id
      document.body.appendChild(this.$container); // 插入容器到body
    }
  }

  renderConext(context) {
    if (this.$box === false) {
      const box = document.createElement('div');
      box.className = 'toast-box';
      this.$box = box;
    } else {
      this.$box.innerHTML = '';
    }
    this.$box.innerText = context;
    this.$container.appendChild(this.$box);
  }

  // 弹出消息
  toast(context, time = 2000) {
    this.$container.classList.add('show');
    this.renderConext(context);
    setTimeout(() => {
      this.$container.classList.remove('show');
    }, time);
  }
}
